import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import companyApi from './actions'
import { companiesKeys } from './constants'
import type { CompanyPartners } from '@models/company'

export interface UseCompanyPartnersData {
  companyPartners: CompanyPartners[]
  companyPartnersMap: Map<number, CompanyPartners>
}

export const selectData = (data: CompanyPartners[]): UseCompanyPartnersData => {
  return {
    companyPartners: data,
    companyPartnersMap: new Map(data.map(company => [company.id, company])),
  }
}

const useCompanyPartners = (companyId: number, partnerId?: number | null) => {
  const query = useQuery<CompanyPartners[], AxiosError, UseCompanyPartnersData>(
    companiesKeys.companyPartners(companyId),
    () => companyApi.getCompanyPartners(companyId),
    {
      select: selectData,
      enabled: !!companyId && !partnerId,
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  )

  return query
}

export default useCompanyPartners
